export default "__VITE_ASSET__t$6xXa3F__ 720w";